<template>
    <div class="fullPage">
        <img src="../../../assets/image/banner/banner3.jpg" alt class="fullWidth"/>
        <div class="main-center main-top">
            <!--对账单信息查询-->
            <el-tabs type="border-card">
                <el-tab-pane :label="$t('billsManagement.title')" class="searchComposite">
                    <div>
                        <div class="flex flex-space-around">
                            <!--船名/航次-->
                            <div class="inputName">
                                <el-col :span="7">
                                    <span class="inputName-title">
                                        {{$t('billsManagement.vvl')}}
                                    </span>
                                    <el-input v-model="vesselCode"
                                              :placeholder="$t('common.pleaseEnter')"
                                              clearable/>
                                </el-col>
                                <el-col :span="7">
                                    <el-input v-model="voyageNo" :placeholder="$t('common.pleaseEnter')"
                                              clearable/>
                                </el-col>
                                <el-col :span="5">
                                    <el-input v-model="voyageLeg" :placeholder="$t('common.pleaseEnter')"
                                              clearable/>
                                </el-col>

                                <!--船名航次VVL弹框-->
                                <el-popover ref="popover" placement="bottom" width="700" trigger="click"
                                            @show="initVvlSearchData"
                                            @hide="boatListShow=false">
                                    <div>
                                        <div class="flex flex-space-between">
                                            <!--船名查询条件-->
                                            <div class="inputName-left boatBox">
                                                <div class="inputName-title-left">
                                                        <span>
                                                            {{$t('booking.popover.vessel')}}
                                                        </span>
                                                </div>
                                                <el-input v-model="vesselCode"
                                                          :placeholder="$t('common.pleaseEnter')"
                                                          clearable
                                                          @focus="showVesselList">
                                                    <img src="../../../assets/image/icon/classification.svg"
                                                         slot="suffix"
                                                         @click="showVesselList">
                                                </el-input>
                                                <!--船名列表-->
                                                <div class="boatBox-list-box" v-show="boatListShow">
                                                    <div class="boatBox-top flex">
                                                        <div class="left">
                                                            {{$t('booking.popover.vesselCode')}}
                                                        </div>
                                                        <div class="right">
                                                            {{$t('booking.popover.vesselNameCn')}}
                                                        </div>
                                                    </div>
                                                    <ul>
                                                        <li v-for="(i,j) in boatList" class="flex"
                                                            :key="j"
                                                            @click="checkBoatData(i)">
                                                            <div class="left">{{i.vesselCode}}</div>
                                                            <div class="right">{{i.vesselNameCn}}</div>
                                                        </li>
                                                    </ul>
                                                </div>
                                            </div>
                                            <!--船中文名查询条件-->
                                            <div class="inputName-left">
                                                <div class="inputName-title-left">
                                                        <span>
                                                            {{$t('booking.popover.vesselNameCn')}}
                                                        </span>
                                                </div>
                                                <el-input v-model="vesselName"
                                                          :placeholder="$t('common.pleaseEnter')"
                                                          clearable/>
                                            </div>
                                            <!--VVL查询按钮-->
                                            <el-button class="popoverInner" size="small" icon="el-icon-search"
                                                       @click="vvlSearch">
                                                {{findButton}}
                                            </el-button>
                                        </div>
                                        <div class="flex flex-space-between">
                                            <!--航次查询条件-->
                                            <div class="inputName-left">
                                                <div class="inputName-title-left">
                                                        <span>
                                                            {{$t('booking.popover.voyageNo')}}
                                                        </span>
                                                </div>
                                                <el-input v-model="voyageNo"
                                                          :placeholder="$t('common.pleaseEnter')"
                                                          clearable/>
                                            </div>
                                            <!--航段查询条件-->
                                            <div class="inputName-left">
                                                <div class="inputName-title-left">
                                                        <span>
                                                            {{$t('booking.popover.voyageLeg')}}
                                                        </span>
                                                    <span style="visibility:hidden">占位</span>
                                                </div>
                                                <el-input v-model="voyageLeg"
                                                          :placeholder="$t('common.pleaseEnter')"
                                                          clearable/>
                                            </div>
                                            <!--VVL关闭按钮-->
                                            <el-button size="small" class="popoverInner"
                                                       icon="el-icon-warning-outline"
                                                       @click="closePopoverView">
                                                {{closeButton}}
                                            </el-button>
                                        </div>
                                        <!--船名数据查询表格-->
                                        <el-table :data="popData" style="width:100%;margin-top:5px"
                                                  max-height="300" highlight-current-row
                                                  :header-cell-style="{background:'#E9E9E9',height:'36px',padding:0}"
                                                  :row-style="{height:'35px'}" :cell-style="{padding:'0px'}"
                                                  :empty-text="$t('common.noData')"
                                                  @row-dblclick="popRowDblclick"
                                                  @row-click="popRowClick">
                                            <!--序号-->
                                            <el-table-column min-width="60" type="index"
                                                             :label="$t('booking.popover.no')"
                                                             align="center"></el-table-column>
                                            <!--船舶代码-->
                                            <el-table-column min-width="110" prop="vesselCode"
                                                             :label="$t('booking.popover.vesselCode')"
                                                             align="center"></el-table-column>
                                            <!--船名-->
                                            <el-table-column min-width="190" prop="vesselName"
                                                             :label="$t('booking.popover.vessel')"
                                                             align="center"></el-table-column>
                                            <!--船中文名-->
                                            <el-table-column min-width="140" prop="vesselNameCn"
                                                             :label="$t('booking.popover.vesselNameCN')"
                                                             align="center"></el-table-column>
                                            <!--航次-->
                                            <el-table-column min-width="100" prop="voyageNo"
                                                             :label="$t('booking.popover.voyageNo')"
                                                             align="center"></el-table-column>
                                            <!--航段-->
                                            <el-table-column min-width="110" prop="voyageLeg"
                                                             :label="$t('booking.popover.voyageLeg')"
                                                             align="center"></el-table-column>
                                        </el-table>
                                        <div class="flex flex-space-between">
                                            <div class="topMargin flex1">
                                                {{getTotalDisplay}}
                                            </div>
                                            <!--VVL确认按钮-->
                                            <el-button class="topMargin" type="primary"
                                                       @click="popConfirm">
                                                {{confirmButton}}
                                            </el-button>
                                            <!--VVL pagination分页条-->
                                            <div class="pagination flex1">
                                                <el-pagination small layout="sizes,pager"
                                                               :page-size="popPageSize" :page-sizes="[5, 10]"
                                                               :total="popTotal"
                                                               :pager-count="popPageCount"
                                                               :current-page="popPageNum"
                                                               @size-change="popHandleSizeChange"
                                                               @current-change="popHandleCurrentChange"
                                                               max-height="600"></el-pagination>
                                            </div>
                                        </div>
                                    </div>
                                    <img slot="reference" style="cursor:pointer" class="voyageIcon"
                                         src="../../../assets/image/voyage.png"/>
                                </el-popover>
                            </div>
                            <!--对账单号-->
                            <div class="inputName">
                                <span class="inputName-title">{{$t('billsManagement.soaNo')}}</span>
                                <el-input v-model="soaNo" type="textarea"
                                          :placeholder="$t('common.multiSOANoEnter')"
                                          maxlength="2000" show-word-limit/>
                            </div>
                            <!--提单号-->
                            <div class="inputName">
                                <span class="inputName-title">{{$t('billsManagement.blNo')}}</span>
                                <el-input v-model="blNo"
                                          :placeholder="$t('common.pleaseEnter')"
                                          clearable/>
                            </div>
                            <!--确认状态-->
                            <div class="inputName">
                                <span class="inputName-title">{{$t('billsManagement.confirmStatus')}}</span>
                                <el-select v-model="search.confirmStatus"
                                           :placeholder="$t('common.pleaseSelect')"
                                           clearable
                                           @change="updateInvoiceStatusOptions">
                                    <el-option v-for="item in confirmStatusOptions"
                                               :key="item.codeValue" :label="getDisplayValue(item)" :value="item.codeValue">
                                        <span style="float: left">{{item.displayValueCn}}</span>
                                        <span style="float: right; color: #8492a6; font-size: 13px">{{item.displayValue}}</span>
                                    </el-option>
                                </el-select>
                            </div>
                        </div>
                        <div class="flex flex-space-around topMargin">
                            <!--确认时间从-->
                            <div class="inputName">
                                <span class="inputName-title">{{$t('billsManagement.confirmDateStart')}}</span>
                                <el-date-picker v-model="search.confirmDateStart" type="date" class="dateInput"
                                                :placeholder="$t('common.pleaseSelectDate')"/>
                            </div>
                            <!--确认时间到-->
                            <div class="inputName">
                                <span class="inputName-title">{{$t('billsManagement.confirmDateEnd')}}</span>
                                <el-date-picker v-model="search.confirmDateEnd" type="date" class="dateInput"
                                                :placeholder="$t('common.pleaseSelectDate')"/>
                            </div>
                            <!--创建时间从-->
                            <div class="inputName">
                                <span class="inputName-title">{{$t('billsManagement.createTimeStart')}}</span>
                                <el-date-picker v-model="search.createTimeStart" type="date" class="dateInput"
                                                :placeholder="$t('common.pleaseSelectDate')"/>
                            </div>
                            <!--创建时间到-->
                            <div class="inputName">
                                <span class="inputName-title">{{$t('billsManagement.createTimeEnd')}}</span>
                                <el-date-picker v-model="search.createTimeEnd" type="date" class="dateInput"
                                                :placeholder="$t('common.pleaseSelectDate')"/>
                            </div>
                        </div>
                        <div class="flex flex-space-around topMargin">
                            <!--开票状态-->
                            <div class="inputName">
                                <span class="inputName-title">{{$t('billsManagement.invoiceStatus')}}</span>
                                <el-select v-model="search.invoiceStatus"
                                           :placeholder="$t('common.pleaseSelect')"
                                           clearable>
                                    <el-option v-for="item in invoiceStatusOptions"
                                               :key="item.codeValue" :label="getDisplayValue(item)" :value="item.codeValue" :disabled="item.disabled">
                                        <span style="float: left">{{item.displayValueCn}}</span>
                                        <span style="float: right; color: #8492a6; font-size: 13px">{{item.displayValue}}</span>
                                    </el-option>
                                </el-select>
                            </div>
                            <el-col style="width: 50%;text-align: right">
<!--                                &lt;!&ndash;待确认金额&ndash;&gt;-->
<!--                                <div class="inputName">-->
<!--                                    <el-tag type="info">待确认金额</el-tag>-->
<!--                                    <span style="margin-left: 5px;font-size: 15px;color: #606266;">{{amount2BeConfirmed}}</span>-->
<!--                                    <span style="margin-left: 15px; margin-right: 15px">|</span>-->
<!--                                    <el-tag type="info">待对账金额</el-tag>-->
<!--                                    <span style="margin-left: 5px; margin-right: 15px;font-size: 15px;color: #606266">{{amount2BeInvoiced}}</span>-->
<!--                                </div>-->
                            </el-col>
                            <div class="searchBtn">
                                <el-button type="primary" icon="el-icon-search"
                                           @click="searchBtnClick">
                                    {{searchButton}}
                                </el-button>
                                <el-button icon="el-icon-refresh"
                                           @click="resetBtnClick">
                                    {{resetButton}}
                                </el-button>
                            </div>
                        </div>
                    </div>
                </el-tab-pane>
            </el-tabs>
            <!--查询结果-->
            <div class="contentListCom">
                <result-bar>
                    <div slot="resultRight">
                        <!--全选-->
                        <el-button icon="el-icon-my-selectAll" @click="checkAllBtnClick(true)">
                            {{selectAll}}
                        </el-button>
                        <!--反选-->
                        <el-button icon="el-icon-my-selectInverse" @click="checkAllBtnClick(false)">
                            {{selectInverse}}
                        </el-button>
                        <!--新增-->
                        <el-button icon="el-icon-circle-plus" @click="newBtnClick">
                            {{newButton}}
                        </el-button>
                        <!--删除-->
                        <el-button icon="el-icon-remove" @click="deleteBtnClick">
                            {{deleteButton}}
                        </el-button>
                        <!--账单确认-->
                        <el-button icon="el-icon-s-claim" @click="confirmBtnClick">
                            {{$t('billsManagement.button.confirmBtn')}}
                        </el-button>
                        <!--取消确认-->
                        <el-button icon="el-icon-s-release" @click="cancelConfirmBtnClick">
                            {{$t('billsManagement.button.cancelConfirmBtn')}}
                        </el-button>
                        <!--申请开票-->
                        <el-button icon="el-icon-s-finance" @click="batchInvoiceBtnClick">
                            {{$t('billsManagement.button.invoiceBtn')}}
                        </el-button>
                        <el-dropdown style="margin-left: 10px" trigger="click"
                                     @command="billsDownload">
                            <el-button>
                                {{$t('billsManagement.button.billsDownload')}}<i class="el-icon-arrow-down el-icon--right"></i>
                            </el-button>
                            <el-dropdown-menu slot="dropdown">
                                <el-dropdown-item command="PDF">
                                    <i class="el-icon-download">{{$t('billsManagement.button.pdfDownload')}}</i>
                                </el-dropdown-item>
                                <el-dropdown-item command="EXCEL">
                                    <i class="el-icon-download">{{$t('billsManagement.button.excelDownload')}}</i>
                                </el-dropdown-item>
                            </el-dropdown-menu>
                        </el-dropdown>
                        <vxe-switch v-model="showViewFlag" style="margin-left: 5px"
                                    open-label="common.cardView" close-label="common.tableView"
                                    open-icon="el-icon-notebook-2" close-icon="vxe-icon-table"
                                    open-value="card" close-value="table" @change="handleViewStyle">
                        </vxe-switch>
                    </div>
                </result-bar>
                <!--无数据组件-->
                <div v-if="showNoDataView || tableBillReceivableData.length === 0" class="noData">
                    <no-data-view/>
                </div>

                <!--查询结果-->
                <div class="contentListCom" v-else>
                    <!--卡片视图-->
                    <div class="oneContent" v-for="(data,index) in tableBillReceivableData" :key="index" v-if="showViewFlag==='card'">
                        <template>
                            <div class="top overflow">
                                <template>
                                    <template>
                                        <!--多选控件-->
                                        <el-checkbox class="checkOne l" v-model="data.checked" :key="index"
                                                     @change="checkOneMethod(index,data.checked)"></el-checkbox>
                                        <!--对账单号-->
                                        <p class="listContent l">
                                            <span class="firstSpan">1.{{$t('billsManagement.soaNo')}}：</span>
                                            <span class="secondSpan blueColor">{{data.soaNo}}</span>
                                        </p>
                                    </template>
                                    <!--查看明细按钮-->
                                    <el-button class="normalListButton r red-button feeDetail" size="small"
                                               icon="el-icon-edit" @click="editBtnClick(data)">
                                        {{detailsButton}}
                                    </el-button>
                                </template>
                            </div>
                            <div class="center flexDiv">
                                <!--对账单开票状态图标-->
                                <!--未确认-->
                                <div class="typeImg accountUnconfirmedImgEn" v-show="getCurLanguage() == 'en' && data.confirmFlag == 0 && data.invoiceFlag == 0"/>
                                <div class="typeImg accountUnconfirmedImg" v-show="getCurLanguage() != 'en' && data.confirmFlag == 0 && data.invoiceFlag == 0"/>
                                <!--已确认-->
                                <div class="typeImg accountConfirmedImgEn" v-show="getCurLanguage() == 'en' && data.confirmFlag == 1 && (data.invoiceFlag == 0 || data.invoiceFlag == 1)"/>
                                <div class="typeImg accountConfirmedImg" v-show="getCurLanguage() != 'en' && data.confirmFlag == 1 && (data.invoiceFlag == 0 || data.invoiceFlag == 1) == 1"/>
                                <!--取消确认-->
                                <div class="typeImg cancelConfirmedImgEn" v-show="getCurLanguage() == 'en' && data.confirmFlag == 2 && (data.invoiceFlag == 0 || data.invoiceFlag == 1)"/>
                                <div class="typeImg cancelConfirmedImg" v-show="getCurLanguage() != 'en' && data.confirmFlag == 2 && (data.invoiceFlag == 0 || data.invoiceFlag == 1) == 1"/>
                                <!--未开票-->
                                <div class="typeImg accountUnInvoicedImgEn" v-show="getCurLanguage() == 'en' && data.confirmFlag == 1 && data.invoiceFlag == 1"/>
                                <div class="typeImg accountUnInvoicedImg" v-show="getCurLanguage() != 'en' && data.confirmFlag == 1 && data.invoiceFlag == 1"/>
                                <!--部分开票-->
                                <div class="typeImg accountUnInvoicedImgEn" v-show="getCurLanguage() == 'en' && data.confirmFlag == 1 && data.invoiceFlag == 2"/>
                                <div class="typeImg accountUnInvoicedImg" v-show="getCurLanguage() != 'en' && data.confirmFlag == 1 && data.invoiceFlag == 2"/>
                                <!--已开票-->
                                <div class="typeImg accountInvoicedImgEn" v-show="getCurLanguage() == 'en' && data.confirmFlag == 1 && data.invoiceFlag == 3"/>
                                <div class="typeImg accountInvoicedImg" v-show="getCurLanguage() != 'en' && data.confirmFlag == 1 && data.invoiceFlag == 3"/>
                                <!--                            <div class="typeImg accountInvoicedImg" v-show="index == 1"/>-->
                                <el-descriptions style="margin-right: 150px" size="medium" :column=3>
                                    <!--客户名称-->
                                    <el-descriptions-item :label="$t('billsManagement.balanceUnitsEn')">
                                        <descriptionsTooltip :value="data.balanceUnitsEn"
                                                             :subValue="getSimplyContent(data.balanceUnitsEn)"
                                                             :maxLength="maxLength"></descriptionsTooltip>
                                    </el-descriptions-item>
                                    <!--客户名称(CN)-->
                                    <el-descriptions-item :label="$t('billsManagement.balanceUnitsCn')">
                                        <descriptionsTooltip :value="data.balanceUnitsCn"
                                                             :subValue="getSimplyContent(data.balanceUnitsCn)"
                                                             :maxLength="maxLength"></descriptionsTooltip>
                                    </el-descriptions-item>
                                    <!--币种-->
                                    <el-descriptions-item :label="$t('billsManagement.currency')">
                                        <el-tag size="small" v-if="data.currency === 'CNY'">{{data.currency}}</el-tag>
                                        <el-tag size="small" class="blue_tag" v-else>{{data.currency}}</el-tag>
                                    </el-descriptions-item>
                                    <!--金额-->
                                    <el-descriptions-item :label="$t('billsManagement.amount')">{{data.amount}}</el-descriptions-item>
                                    <!--创建人-->
                                    <el-descriptions-item :label="$t('billsManagement.createdByUser')">{{data.createdByUser}}</el-descriptions-item>
                                    <!--创建时间-->
                                    <el-descriptions-item :label="$t('billsManagement.createdDtmLoc')">{{data.createdDtmLoc}}</el-descriptions-item>
                                    <!--确认人-->
                                    <el-descriptions-item :label="$t('billsManagement.confirmByUser')">{{data.confirmByUser}}</el-descriptions-item>
                                    <!--确认时间-->
                                    <el-descriptions-item :label="$t('billsManagement.confirmDate')">{{data.confirmDate}}</el-descriptions-item>
                                </el-descriptions>
                            </div>
                        </template>
                        <div class="bottom overflow">
                            <!--备注-->
                            <div class="l flexDiv leftMessage">
                                <p class="documentValid fontWeight msg">{{$t('billsManagement.remark')}}：{{data.remark}}</p>
                            </div>
                            <div class="r flexDiv">
                                <template>
                                    <!--账单确认-->
                                    <el-button class="normalListButton" type="warning" style="height: 70%; margin-top: 4px"
                                               icon="el-icon-s-claim" size="small"
                                               @click="confirmOneBtnClick(data)">{{$t('billsManagement.button.confirmBtn')}}</el-button>
                                    <!--申请开票-->
                                    <el-button class="normalListButton blue-button" style="height: 70%; margin-top: 4px"
                                               icon="el-icon-s-finance" size="small"
                                               @click="invoiceBtnClick(data)">{{$t('billsManagement.button.invoiceBtn')}}</el-button>
                                    <!--下载对账单-->
                                    <el-button class="normalListButton" type="primary" plain style="height: 70%; margin-top: 4px"
                                               icon="el-icon-download" size="small">{{$t('billsManagement.button.billsDownload')}}</el-button>
                                    <!--删除-->
                                    <el-button class="normalListButton" style="height: 70%; margin-top: 4px"
                                               type="info" icon="el-icon-delete-solid" size="small"
                                               @click="deleteOneBtnClick(data)">{{deleteButton}}</el-button>
                                </template>
                            </div>
                        </div>
                    </div>
                    <!--对账单数据表格pagination分页条-->
                    <div class="pagination" v-if="showViewFlag==='card'">
                        <div>
                            <el-pagination background layout="total,sizes,slot,prev, pager, next"
                                           max-height="600"
                                           :page-size="pageSize" :pager-count="pageCount"
                                           :page-sizes="[10, 20, 50, 100, 200]" :total="total"
                                           :current-page="pageNum"
                                           @size-change="handleSizeChange"
                                           @current-change="handleCurrentChange"/>
                        </div>
                    </div>

                    <!--表格视图-->
                    <div class="mainTable" v-if="showViewFlag==='table'">
                        <vxe-grid show-overflow
                                  ref="tableBillReceivableData" class="vxeTable"
                                  height="500" size="small"
                                  :row-config="{isCurrent: true, isHover: true}"
                                  :column-config="{resizable: true}"
                                  :export-config="{}"
                                  :checkbox-config="{checkStrictly: true}"
                                  @checkbox-change="handleTableBillReceivableChecked"
                                  resizable
                                  keep-source
                                  show-footer
                                  :data="tableBillReceivableData"
                                  :columns="tableColumn"
                                  :toolbar-config="tableToolbar">
                            <!--顶端工具栏插槽-->
                            <template #toolbar_buttons>
                                <vxe-button @click="exportDataEvent" status="primary" type="text" icon="vxe-icon-file-excel" style="margin-left: 10px">
                                    {{exportDataButton}}</vxe-button>
                                <vxe-button @click="$refs.tableBillReceivableData.hideColumn($refs.tableBillReceivableData.getColumnByField('menu'))" status="primary" type="text" icon="vxe-icon-eye-fill-close" style="margin-left: 10px">
                                    {{$t('common.menuHide')}}</vxe-button>
                                <vxe-button @click="$refs.tableBillReceivableData.showColumn($refs.tableBillReceivableData.getColumnByField('menu'))" status="primary" type="text" icon="vxe-icon-eye-fill" style="margin-left: 10px">
                                    {{$t('common.menuShow')}}</vxe-button>
                            </template>
                            <!--确认状态插槽-->
                            <template #column_confirmFlag="{ row }">
                                <!--未确认-->
                                <span class="yellowColor" v-if="row.confirmFlag == 0">{{getConfirmStatusDisplay(row)}}</span>
                                <!--已确认-->
                                <span class="greenColor" v-else-if="row.confirmFlag == 1">{{getConfirmStatusDisplay(row)}}</span>
                                <!--取消确认-->
                                <span class="grayColor" v-else-if="row.confirmFlag == 2">{{getConfirmStatusDisplay(row)}}</span>
                                <!--默认-->
                                <span v-else>{{getConfirmStatusDisplay(row)}}</span>
                            </template>
                            <!--开票状态插槽-->
                            <template #column_invoiceFlag="{ row }">
                                <!--未开票-->
                                <span class="blueColor" v-if="row.invoiceFlag == 1">{{getInvoiceStatusDisplay(row)}}</span>
                                <!--部分开票-->
                                <span class="purpleColor" v-else-if="row.invoiceFlag == 2">{{getInvoiceStatusDisplay(row)}}</span>
                                <!--已开票-->
                                <span class="purpleColor" v-else-if="row.invoiceFlag == 3">{{getInvoiceStatusDisplay(row)}}</span>
                                <!--默认-->
                                <span v-else>{{getInvoiceStatusDisplay(row)}}</span>
                            </template>
                            <!--币种插槽-->
                            <template #column_currency="{ row }">
                                <el-tag size="small" v-if="row.currency === 'CNY'">{{row.currency}}</el-tag>
                                <el-tag size="small" class="blue_tag" v-else>{{row.currency}}</el-tag>
                            </template>
                            <!--操作按钮插槽-->
                            <template #operate_default="{ row }">
                                <!--明细按钮-->
                                <el-tooltip class="item" effect="dark" :content="viewDetails" placement="bottom-start">
                                    <el-button style="line-height: 15px; height: 22px; width: 22px"
                                               size="mini" type="primary" icon="el-icon-edit" circle @click="editBtnClick(row)"></el-button>
                                </el-tooltip>
                                <!--删除按钮-->
                                <el-tooltip class="item" effect="dark" :content="deleteButton" placement="bottom-start">
                                    <el-button style="line-height: 15px; height: 22px; width: 22px"
                                               size="mini" type="info" icon="el-icon-delete" circle @click="deleteOneBtnClick(row)"></el-button>
                                </el-tooltip>
                                <!--账单确认按钮-->
                                <el-button size="mini" style="margin-top: 4px; color: #F4A000" type="text" icon="el-icon-s-claim"
                                           @click="confirmOneBtnClick(row)">{{$t('billsManagement.button.confirmBtn')}}</el-button>
                                <!--申请开票按钮-->
                                <el-button size="mini" style="margin-top: 4px; color: #409EFF" type="text" icon="el-icon-s-finance"
                                           @click="invoiceBtnClick(row)">{{$t('billsManagement.button.invoiceBtn')}}</el-button>
                                <!--下载对账单按钮-->
                                <el-button size="mini" style="margin-top: 4px" type="text" icon="vxe-icon-download">
                                    {{$t('billsManagement.button.billsDownload')}}</el-button>
                            </template>
                            <template #pager>
                                <vxe-pager
                                        :layouts="['PrevPage', 'JumpNumber', 'NextPage', 'FullJump', 'Sizes', 'Total']"
                                        :current-page.sync="pageNum"
                                        :page-size.sync="pageSize"
                                        :page-sizes="[10, 20, 50, 100, 200]"
                                        :total="total"
                                        @page-change="handleTablePageChange">
                                </vxe-pager>
                            </template>
                        </vxe-grid>
                    </div>
                </div>
            </div>
        </div>

        <!--页面底部组件-->
        <div class="footerSpan">
            <span></span>
        </div>
    </div>
</template>

<script>
    import noDataView from "@/components/noDataView";
    import resultBar from "@/components/resultBar";

    export default {
        name: "billsManagement",
        computed: {
            // 船名航次查询条件
            vesselCode: {
                get: function () {
                    return this.search.vesselCode;
                },
                set: function (val) {
                    this.search.vesselCode = val.toUpperCase();
                }
            },
            vesselName: {
                get: function () {
                    return this.search.vesselName;
                },
                set: function (val) {
                    this.search.vesselName = val.toUpperCase();
                }
            },
            voyageNo: {
                get: function () {
                    return this.search.voyageNo;
                },
                set: function (val) {
                    this.search.voyageNo = val.toUpperCase();
                }
            },
            voyageLeg: {
                get: function () {
                    return this.search.voyageLeg;
                },
                set: function (val) {
                    this.search.voyageLeg = val.toUpperCase();
                }
            },
            // 提单号查询条件
            blNo: {
                get: function () {
                    return this.search.blNo;
                },
                set: function (val) {
                    this.search.blNo = val.toUpperCase();
                }
            },
            // 对账单号查询条件
            soaNo: {
                get: function () {
                    return this.search.soaNo;
                },
                set: function (val) {
                    this.search.soaNo = val.toUpperCase();
                }
            },
            searchButton() {//查询按钮
                return this.$t("common.searchButton");
            },
            resetButton() {//重置按钮
                return this.$t("common.resetButton");
            },
            editButton() {//编辑按钮
                return this.$t("common.editButton");
            },
            newButton() {//新增按钮
                return this.$t("common.newButton");
            },
            deleteButton() {//删除按钮
                return this.$t("common.deleteButton");
            },
            viewDetails() {
                return this.$t('common.viewDetails');
            },
            exportDataButton() {
                return this.$t('common.exportTableData');
            },
            detailsButton() {//明细按钮
                return this.$t("common.detailsButton");
            },
            selectAll() {//全选
                return this.$t("common.selectAll");
            },
            selectInverse() {//反选
                return this.$t("common.selectInverse");
            },
            findButton() {//搜索按钮
                return this.$t("common.findButton");
            },
            getTotalDisplay() {
                return this.$t("common.total").replace("?", this.popTotal);
            },
            closeButton() {//关闭按钮
                return this.$t("common.closeButton");
            },
            confirmButton() {//确认按钮
                return this.$t("common.confirmButton");
            },
            cancelButton() {//取消按钮
                return this.$t("common.cancelButton");
            },
        },
        components: {
            noDataView,
            resultBar
        },
        data() {
            return {
                isSearchClick: false,       //控制查询按钮是否重复点击
                boatListShow: false,        //控制船名航次查询框是否显示
                showNoDataView: false,
                showViewFlag: "card",       //控制数据是否展开显示 card：卡片  table：表格
                maxLength: 25,

                confirmStatusOptions: [     // 确认状态
                    {codeValue: 0, displayValueCn: "未确认", displayValue: "UNCONFIRMED"},
                    {codeValue: 1, displayValueCn: "已确认", displayValue: "CONFIRMED"},
                    {codeValue: 2, displayValueCn: "取消确认", displayValue: "CANCEL CONFIRMED"},
                ],
                invoiceStatusOptions: [     // 开票状态
                    {codeValue: 1, displayValueCn: "未开票", displayValue: "UNINVOICED", disabled:false},
                    {codeValue: 2, displayValueCn: "部分开票", displayValue: "PARTIAL INVOICED", disabled:false},
                    {codeValue: 3, displayValueCn: "已开票", displayValue: "INVOICED", disabled:false},
                ],

                // 对账单查询参数
                search: {
                    vesselCode: "",         // 船舶代码
                    vesselName: "",         // 船舶名称
                    voyageNo: "",           // 航次
                    voyageLeg: "",          //航段
                    soaNo: "",              //对账单号
                    blNo: "",               //提单号
                    confirmStatus: "",       //确认状态
                    invoiceStatus: "",       //开票状态
                    confirmDateStart: "",   //确认时间从
                    confirmDateEnd: "",     //确认时间到
                    createTimeStart: "",    //创建时间从
                    createTimeEnd: "",      //创建时间到
                },

                amount2BeConfirmed: 0.00,   //待确认金额
                amount2BeInvoiced: 0.00,    //待开票金额

                // 【对账单数据表格】
                tableBillReceivableData: [],
                tableBillReceivableDataChecked: [], //对账单数据表格多选列表
                tableToolbar: {
                    perfect: true,
                    zoom: true,
                    custom: true,
                    slots: {
                        buttons: 'toolbar_buttons'
                    }
                },
                tableColumn: [
                    { align: 'center' ,type: 'checkbox', width: 40 },
                    { align: 'center' ,type: 'seq', title: 'confirmFreight.no', width: 60, sortable: true, },//序号
                    { align: 'center' ,field: 'confirmFlag', title: 'billsManagement.confirmStatus', minWidth: 130, sortable: true,
                        slots: {   //该处展示自定义插槽，可以将数据封装到想用的组件里，视觉效果更佳
                            default: 'column_confirmFlag'
                        }
                    },//对账单状态
                    { align: 'center' ,field: 'invoiceFlag', title: 'billsManagement.invoiceStatus', minWidth: 120, sortable: true,
                        slots: {   //该处展示自定义插槽，可以将数据封装到想用的组件里，视觉效果更佳
                            default: 'column_invoiceFlag'
                        }
                    },//开票状态
                    { align: 'center' ,field: 'soaNo', title: 'billsManagement.soaNo', minWidth: 130, sortable: true, },//对账单号
                    { align: 'center' ,field: 'balanceUnitsEn', title: 'billsManagement.balanceUnitsEn', minWidth: 220, sortable: true, },//客户名称
                    { align: 'center' ,field: 'balanceUnitsCn', title: 'billsManagement.balanceUnitsCn', minWidth: 220, sortable: true, },//客户名称(CN)
                    { align: 'center' ,field: 'amount', title: 'billsManagement.amount', minWidth: 120, sortable: true, },//金额
                    { align: 'center' ,field: 'currency', title: 'billsManagement.currency', minWidth: 100, sortable: true,
                        slots: {
                            default: 'column_currency'
                        }
                    },//币种
                    { align: 'center' ,field: 'createdByUser', title: 'billsManagement.createdByUser', minWidth: 140, sortable: true,  },//创建人
                    { align: 'center' ,field: 'createdDtmLoc', title: 'billsManagement.createdDtmLoc', minWidth: 180, sortable: true,  },//创建时间
                    { align: 'center' ,field: 'confirmByUser', title: 'billsManagement.confirmByUser', minWidth: 140, sortable: true,  },//确认人
                    { align: 'center' ,field: 'confirmDate', title: 'billsManagement.confirmDate', minWidth: 150, sortable: true,  },//确认时间
                    { align: 'center' ,field: 'menu', title: 'common.menuColumn', minWidth: 365, fixed: 'right',
                        titlePrefix: {
                            icon: 'el-icon-s-tools'
                        },
                        slots: {
                            default: 'operate_default'
                        }
                    }
                ],
                // 【船名/航次弹框 船名数据表格】
                boatList: [],
                // 【船名/航次弹框 VVL数据表格】
                popData: [],

                // 船名/航次弹框分页参数
                popPageCount: 5,
                popPageNum: 1,
                popPageSize: 5,
                popTotal: 0,
                // 对账单数据分页参数
                pageCount: 5,
                pageNum: 1,
                pageSize: 10,
                total: 20,
            };
        },
        methods: {
            /************************************ 工具栏按钮点击事件 ************************************/
            /**
             * 对账单查询按钮点击
             */
            searchBtnClick() {
                if (this.isSearchClick) {//上一次查询未结束时不允许重复发起请求
                    return;
                }
                this.isSearchClick = true;

                // 查询条件校验
                if(!this.validateSearch()){
                    this.isSearchClick = false;//设置查询按钮为可点击状态,允许再次发起请求
                    return;
                }

                // 声明一个loading对象
                this.loadingtuo = this.$loading({
                    lock: true, // 设置加载时是否锁屏,锁屏状态加载区域无法操作
                    text: this.$t('message.searching'),     // 加载动画的文字
                    spinner: 'el-icon-loading',             // 引入的loading图标
                    background: "rgb(0,0,0,0.1)",
                    // target: document.querySelector(".searchComposite") // 设置加载动画区域
                });
                let that = this;
                this.axios({
                    method: 'post',
                    url: '/api/statementOfAccount/statementOfAccountQuery',
                    data: {
                        vesselCode: this.search.vesselCode,         // 船舶代码
                        vesselName: this.search.vesselName,         // 船舶名称
                        voyageNo: this.search.voyageNo,             // 航次
                        voyageLeg: this.search.voyageLeg,           //航段
                        soaNo: this.search.soaNo,                   //对账单号
                        blNo: this.search.blNo,                     //提单号
                        confirmFlag: this.search.confirmStatus,   //确认状态
                        invoiceFlag: this.search.invoiceStatus,   //开票状态
                        confirmDateFrom: this.search.confirmDateStart === "" ? "" : this.formatDate(
                            {date: this.search.confirmDateStart, formatStr: 'yyyy-MM-dd'}
                        ),   //确认时间从
                        confirmDateTo: this.search.confirmDateEnd === "" ? "" : this.formatDate(
                            {date: this.search.confirmDateEnd, formatStr: 'yyyy-MM-dd'}
                        ),  //确认时间到
                        createdTimeFrom: this.search.createTimeStart === "" ? "" : this.formatDate(
                            {date: this.search.createTimeStart, formatStr: 'yyyy-MM-dd'}
                        ),  //创建时间从
                        createdTimeTo: this.search.createTimeEnd === "" ? "" : this.formatDate(
                            {date: this.search.createTimeEnd, formatStr: 'yyyy-MM-dd'}
                        ),  //创建时间到
                        pageNum: this.pageNum,
                        pageSize: this.pageSize
                    },
                    headers: {
                        'Accept-language': localStorage.getItem("locale")
                    }
                }).then(response => {
                    that.loadingtuo.close();
                    this.responseCode = response.data.backMessage;
                    if (response.data.backCode === "200") {
                        this.showNoDataView = false;
                        let data = response.data.object.list;
                        this.tableBillReceivableData = this.refreshChecked(data);
                        this.total = response.data.object.total;
                    } else {
                        this.showMessage(false, this.responseCode, "error");
                        if (response.data.backCode === "207"){
                            // 当前未登录，跳转到登录页面
                            this.$router.push({
                                path: '/homePage',
                                query: {redirect: "/confirmFreight"} // 将跳转的路由path作为参数，登录成功后跳转到该路由
                            });
                        }
                    }
                    this.isSearchClick = false;//设置查询按钮为可点击状态,允许再次发起请求
                }).catch(error => {
                    that.loadingtuo.close();//关闭进度条
                    if (error.data) {
                        this.responseCode = error.data.backMessage;
                        this.showMessage(false, this.responseCode, "error");
                    } else {
                        this.showMessage(false, error, "error");
                    }
                    this.isSearchClick = false;//设置查询按钮为可点击状态,允许再次发起请求
                });
            },
            /**
             * 查询条件校验
             */
            validateSearch(){
                return true;
            },
            /**
             * 对账单重置按钮点击
             */
            resetBtnClick() {//重置按钮点击
                this.search.vesselCode = "";         // 船舶代码
                this.search.vesselName = "";         // 船舶名称
                this.search.voyageNo = "";           // 航次#{invoiceFlag} = 1 and
                this.search.voyageLeg = "";           //航段
                this.search.soaNo = "";                   //对账单号
                this.search.blNo = "";                     //提单号
                this.search.confirmStatus = "";   //确认状态
                this.search.invoiceStatus = "";   //开票状态
                this.search.confirmDateStart = "";   //确认时间从
                this.search.confirmDateEnd = "";  //确认时间到
                this.search.createTimeStart = "";  //创建时间从
                this.search.createTimeEnd = "";  //创建时间到
                this.search.pageNum = 1;
                this.search.pageSize = 10;
                // 还原开票状态选项禁用标志
                this.invoiceStatusOptions = [     // 开票状态
                    {codeValue: 1, displayValueCn: "未开票", displayValue: "UNINVOICED", disabled:false},
                    {codeValue: 2, displayValueCn: "部分开票", displayValue: "PARTIAL INVOICED", disabled:false},
                    {codeValue: 3, displayValueCn: "已开票", displayValue: "INVOICED", disabled:false},
                ];
            },
            /**
             * 全选/反选按钮点击
             */
            checkAllBtnClick(isCheck){
                // 先清空对账单多选列表
                this.tableBillReceivableDataChecked = [];
                if(isCheck){
                    // 全选
                    this.tableBillReceivableData.forEach((item,index)=>{
                        item.checked = true;
                        this.checkOneMethod(index, true)
                    })
                }else{
                    // 反选
                    this.tableBillReceivableData.forEach((item,index)=>{
                        let cur = item.checked;
                        item.checked = !cur;
                        this.checkOneMethod(index, !cur)
                    })
                }
            },
            /**
             * 对账单新增按钮点击
             */
            newBtnClick() {
                // 获取当前登录用户信息
                let customer = JSON.parse(sessionStorage.getItem("CUSTOMER"));
                let statementOfAccountInfo = {};
                statementOfAccountInfo.balanceUnits = customer.companyCode;
                statementOfAccountInfo.balanceUnitsEn = customer.companyName;
                statementOfAccountInfo.balanceUnitsCn = customer.companyNameCn;
                statementOfAccountInfo.confirmFlag = 0;//未确认
                statementOfAccountInfo.invoiceFlag = 0;//未开票
                statementOfAccountInfo.soaDetails = [];
                // 跳转到对账单明细编辑页面
                this.$router.push({
                    name: 'billsDetails',
                    params: {
                        statementOfAccountInfo: statementOfAccountInfo,
                        freightReceiveVos: []
                    }
                });
            },
            /**
             * 对账单批量确认按钮点击
             */
            confirmBtnClick(){
                // 获取选中对账单ID
                let statementOfAccountIds = [];
                this.tableBillReceivableDataChecked.forEach(item=>{
                    statementOfAccountIds.push(item.statementOfAccountId);
                });
                // 校验是否勾选数据
                if(statementOfAccountIds.length <= 0){
                    this.showMessage(false, this.$t('message.noDataSelected'), "warning");
                    return;
                }
                this.soaConfirm(statementOfAccountIds);
            },
            /**
             * 对账单单票确认按钮点击
             */
            confirmOneBtnClick(statementOfAccount){
                var statementOfAccountIds=[];
                statementOfAccountIds.push(statementOfAccount.statementOfAccountId);
                // 校验当前对账单确认状态是否为“已确认”状态（1L）
                if (statementOfAccount.confirmFlag == 1) {
                    this.$alert(this.$t('billsManagement.message.cannotConfirmAgain'), this.$t("common.tips"), {
                        confirmButtonText: this.$t("common.okButton")
                    });
                    return;
                }
                this.soaConfirm(statementOfAccountIds);
            },
            soaConfirm(statementOfAccountIds){
                // 调用后端取消确认接口
                this.axios({
                    method: 'post',
                    url: '/api/statementOfAccount/statementOfAccountConfirm',

                    data: {
                        statementOfAccountIds: JSON.stringify(statementOfAccountIds),
                    },
                    headers: {
                        'Accept-language': localStorage.getItem("locale")
                    }
                }).then(response => {
                    this.responseCode = response.data.backMessage;
                    if (response.data.backCode === "200") {
                        this.showMessage(true, this.responseCode, "success");
                        this.searchBtnClick();
                    } else {
                        this.$alert(this.responseCode, this.$t("common.tips"), {
                            confirmButtonText: this.$t("common.okButton")
                        });
                    }
                }).catch(error => {
                    if (error.data) {
                        this.responseCode = error.data.backMessage;
                        this.showMessage(false, this.responseCode, "error");
                    } else {
                        this.showMessage(false, error, "error");
                    }
                });
            },
            /**
             * 对账单取消确认按钮点击
             */
            cancelConfirmBtnClick(){
                // 获取选中对账单ID
                let statementOfAccountIds = [];
                this.tableBillReceivableDataChecked.forEach(item=>{
                    statementOfAccountIds.push(item.statementOfAccountId);
                });
                // 校验是否勾选数据
                if(statementOfAccountIds.length <= 0){
                    this.showMessage(false, this.$t('message.noDataSelected'), "warning");
                    return;
                }
                // 调用后端取消确认接口
                this.axios({
                    method: 'post',
                    url: '/api/statementOfAccount/statementOfAccountCancelConfirm',
                    data: {
                        statementOfAccountIds: JSON.stringify(statementOfAccountIds),
                    },
                    headers: {
                        'Accept-language': localStorage.getItem("locale")
                    }
                }).then(response => {
                    this.responseCode = response.data.backMessage;
                    if (response.data.backCode === "200") {
                        this.showMessage(true, this.responseCode, "success");
                        this.searchBtnClick();
                    } else {
                        this.$alert(this.responseCode, this.$t("common.tips"), {
                            confirmButtonText: this.$t("common.okButton")
                        });
                    }
                }).catch(error => {
                    if (error.data) {
                        this.responseCode = error.data.backMessage;
                        this.showMessage(false, this.responseCode, "error");
                    } else {
                        this.showMessage(false, error, "error");
                    }
                });
            },
            /**
             * 对账单单票申请开票按钮点击
             */
            invoiceBtnClick(data){
                // 校验当前对账单确认状态是否为“已确认”状态（1L）
                if (data.confirmFlag != 1) {
                    this.$alert(this.$t('billsManagement.message.cannotInvoice'), this.$t("common.tips"), {
                        confirmButtonText: this.$t("common.okButton")
                    });
                    return;
                }
                let statementOfAccounts = [];
                // 开票操作确认
                this.$confirm(this.$t('billsManagement.message.invoice'), this.$t("common.pleaseConfirm"), {
                    distinguishCancelAndClose: true,
                    confirmButtonText: this.$t("common.confirmButton"),
                    cancelButtonText: this.$t("common.cancelButton")
                }).then(() => {
                    statementOfAccounts.push(data);
                    // 生成发票内容并打开发票明细页面
                    this.transferToInvoiceDetails(statementOfAccounts);
                });
            },
            /**
             * 对账单批量开票按钮点击
             */
            batchInvoiceBtnClick(){
                // 获取勾选的对账单数据
                let statementOfAccounts = this.tableBillReceivableDataChecked;
                // 开票操作确认
                this.$confirm(this.$t('billsManagement.message.invoice'), this.$t("common.pleaseConfirm"), {
                    distinguishCancelAndClose: true,
                    confirmButtonText: this.$t("common.confirmButton"),
                    cancelButtonText: this.$t("common.cancelButton")
                }).then(() => {
                    // 生成发票内容并打开发票明细页面
                    this.transferToInvoiceDetails(statementOfAccounts);
                });
            },
            transferToInvoiceDetails(statementOfAccounts) {
                if(statementOfAccounts == null || statementOfAccounts.length <= 0){
                    return;
                }

                let statementOfAccountIds = [];
                // 声明一个loading对象
                this.loadingtuo = this.$loading({
                    lock: true, // 设置加载时是否锁屏,锁屏状态加载区域无法操作
                    text: this.$t('billsManagement.message.generatingInvoice'),             // 加载动画的文字
                    spinner: 'el-icon-loading',                     // 引入的loading图标
                    background: "rgb(0,0,0,0.1)",
                });
                let that = this;

                statementOfAccounts.forEach((checked)=>{
                    statementOfAccountIds.push(checked.statementOfAccountId);
                });
                // 对账单开票前校验
                this.axios({
                    method: 'post',
                    url: '/api/invoiceDoc/transferToInvoice',
                    data: {
                        statementOfAccountIds: JSON.stringify(statementOfAccountIds),
                    },
                    headers: {
                        'Accept-language': localStorage.getItem("locale")
                    }
                }).then(response => {
                    this.responseCode = response.data.backMessage;
                    if (response.data.backCode === "200") {//检验成功，允许打印
                        // 获取对账单生成的发票内容
                        let invoiceDocInfo = response.data.object;
                        // 跳转到发票明细页面
                        setTimeout(() => {
                            // 关闭加载中显示
                            that.loadingtuo.close();
                            // this.$router.push({
                            //     name: 'invoiceDetails',
                            //     params: {
                            //         invoiceDocInfo: invoiceDocInfo,
                            //         statementOfAccounts: statementOfAccounts
                            //     }
                            // });
                            var route = this.$router.resolve({
                                name: 'invoiceDetails',
                            });
                            // 将传递参数存到session中
                            sessionStorage.setItem("PASSING_PARAMETERS", JSON.stringify(invoiceDocInfo));
                            sessionStorage.setItem("PASSING_PARAMETERS_1", JSON.stringify(statementOfAccounts));
                            // 打开对账单明细页面
                            window.open(route.href, '_blank')
                        }, 1000);
                    } else {//校验失败，提示校验失败信息
                        that.loadingtuo.close();
                        this.responseCode = response.data.backMessage;
                        this.$alert(this.responseCode, this.$t("common.tips"), {
                            confirmButtonText: this.$t("common.okButton")
                        });
                    }
                }).catch(error => {
                    that.loadingtuo.close();
                    if (error.data) {
                        this.responseCode = error.data.backMessage;
                        this.showMessage(false, this.responseCode, "error");
                    } else {
                        this.showMessage(false, error, "error");
                    }
                });
            },
            /**
             * 对账单批量删除按钮点击
             */
            deleteBtnClick() {
                var statementOfAccountIds = [];
                this.tableBillReceivableDataChecked.forEach(item=>{
                    statementOfAccountIds.push(item.statementOfAccountId);
                });
                // 校验是否勾选数据
                if(statementOfAccountIds.length <= 0){
                    this.showMessage(false, this.$t('message.noDataSelected'), "warning");
                    return;
                }
                this.deleteSoa(statementOfAccountIds);
            },
            /**
             * 对账单单票删除按钮点击
             */
            deleteOneBtnClick(statementOfAccount){
                // console.log(statementOfAccount.confirmFlag)
                var statementOfAccountIds=[];
                statementOfAccountIds.push(statementOfAccount.statementOfAccountId);
                if (statementOfAccount.confirmFlag !== 0) {
                    this.$alert(this.$t('billsManagement.message.cannotDeleted'), this.$t('billsManagement.message.deleteFailed'), {
                        confirmButtonText: this.$t("common.okButton")
                    });
                    return;
                }
                this.$confirm(this.$t('billsManagement.message.deleteSOA'), this.$t("common.pleaseConfirm"), {
                    distinguishCancelAndClose: true,
                    confirmButtonText: this.$t("common.deleteButton"),
                    cancelButtonText: this.$t("common.cancelButton")
                }).then(() => {
                    this.deleteSoa(statementOfAccountIds);
                });
            },
            deleteSoa(statementOfAccountIds){
                this.axios({
                    method: 'post',
                    url: '/api/statementOfAccount/statementOfAccountDel',
                    data: {
                        statementOfAccountIds: JSON.stringify(statementOfAccountIds),
                    },
                    headers: {
                        'Accept-language': localStorage.getItem("locale")
                    }
                }).then(response => {
                    this.responseCode = response.data.backMessage;
                    if (response.data.backCode === "200") {
                        this.showMessage(true, this.responseCode, "success");
                        this.searchBtnClick();
                    } else {
                        this.showMessage(false, this.responseCode, "error");
                        this.$alert( this.responseCode, this.$t('billsManagement.message.deleteFailed'), {
                            confirmButtonText: this.$t("common.okButton")
                        });

                    }
                }).catch(error => {
                    if (error.data) {
                        this.responseCode = error.data.backMessage;
                        this.showMessage(false, this.responseCode, "error");
                    } else {
                        this.showMessage(false, error, "error");
                    }
                });
            },
            /**
             * 对账单下载按钮点击
             */
            billsDownload(type){
                // TODO 对账单下载
                switch (type) {
                    case "PDF":
                        this.showMessage(false, "PDF下载功能正在开发中，敬请期待", "success"); break;
                    case "EXCEL":
                        this.showMessage(false, "Excel下载功能正在开发中，敬请期待", "success"); break;
                }
            },
            /**
             * 查看明细按钮点击
             */
            editBtnClick(data) {
                // // 将当前对账单数据传递至对账单明细页面
                // this.$router.push({
                //     name: 'billsDetails',
                //     params: {
                //         statementOfAccountInfo: data
                //     }
                // });
                var route = this.$router.resolve({
                    name: 'billsDetails',
                });
                // 将传递参数存到session中
                sessionStorage.setItem("PASSING_PARAMETERS", JSON.stringify(data));
                sessionStorage.removeItem("PASSING_PARAMETERS_1");
                // 打开对账单明细页面
                window.open(route.href, '_blank')
            },

            /************************************ 表格多选事件 *************************************/
            /**
             * 对账单记录勾选事件，将选中估价单添加进勾选列表中
             */
            checkOneMethod(index, type) {
                let curData = this.tableBillReceivableData[index];
                if (type) {//选中
                    this.tableBillReceivableDataChecked.push(curData);
                    // 新增表格视图下全选控制
                    if(this.$refs.tableBillReceivableData){
                        this.$refs.tableBillReceivableData.setCheckboxRow(curData, type);
                    }
                } else {//取消选中
                    this.tableBillReceivableDataChecked.forEach((item, index) => {
                        if (item.statementOfAccountId === curData.statementOfAccountId) {
                            this.tableBillReceivableDataChecked.splice(index, 1);
                        }
                    });
                    // 新增表格视图下反选控制
                    if(this.$refs.tableBillReceivableData){
                        this.$refs.tableBillReceivableData.toggleCheckboxRow(curData);
                    }
                }
            },
            /**
             * 对账单数据表格勾选事件，将表格中选中对账单添加进勾选列表中
             */
            handleTableBillReceivableChecked({checked}) {
                // 清空数据checked状态
                this.tableBillReceivableData.forEach((item)=>{
                    item.checked = false;
                });
                // 先清空对账单多选列表
                this.tableBillReceivableDataChecked = [];
                const records = this.$refs.tableBillReceivableData.getCheckboxRecords();
                // 更新卡片视图下数据选中状态
                records.forEach((item)=>{
                    item.checked = true;
                });
                // 更新表格勾选的费用信息
                this.tableBillReceivableDataChecked = records;
            },
            /**
             * 表格数据导出
             */
            exportDataEvent () {
                this.$refs.tableBillReceivableData.openExport({ types: ['csv'] })
            },

            /************************************ 表格分页工具 *************************************/
            /**
             * 对账单数据表格分页条
             */
            handleDemand() {
                this.searchBtnClick();
            },
            handleSizeChange(val) {
                this.pageSize = val;
                this.handleDemand();
                this.$emit("backTop");
            },
            handleCurrentChange(val) {
                this.pageNum = val;
                this.handleDemand(1);
                this.$emit("backTop");
            },
            /**
             * 订舱数据表格分页条(表格视图)
             */
            handleTablePageChange ({ currentPage, pageSize }) {
                this.pageNum = currentPage;
                this.pageSize = pageSize;
                this.searchBtnClick();
            },

            /************************************ 船名航次弹出框 ************************************/
            /**
             * 船名下拉选数据初始化
             */
            initVvlSearchData(){
                // 自动调用查询方法
                this.vvlSearch();
            },
            /**
             * 船名下拉选赋值
             */
            showVesselList() {//船名输入框点击
                this.boatListShow = true;
                this.axios({
                    method: 'get',
                    url: '/api/codedict/getVesselList',
                    headers: {
                        'Accept-language': localStorage.getItem("locale")
                    }
                }).then(response => {
                    this.responseCode = response.data.backMessage;
                    if (response.data.backCode === "200") {
                        this.boatList = response.data.object;
                    } else {
                        this.showMessage(false, this.responseCode, "error");
                    }
                }).catch(error => {
                    if (error.data) {
                        this.responseCode = error.data.backMessage;
                        this.showMessage(false, this.responseCode, "error");
                    } else {
                        this.showMessage(false, error, "error");
                    }
                });
            },
            /**
             * 船名下拉表格数据点击事件
             */
            checkBoatData(boat) {//pop  【船名】下拉选择
                this.search.vesselCode = boat.vesselCode;
                this.search.vesselName = boat.vesselName;
                this.boatListShow = false
            },
            /**
             * 搜索按钮点击事件
             */
            vvlSearch() {
                if (this.isVVLSearchClick) {
                    return;
                }
                this.isVVLSearchClick = true;
                this.axios({
                    method: 'post',
                    url: '/api/voyagePlan/getVVLEntity',
                    data: {
                        voyageNo: this.search.voyageNo,
                        voyageLeg: this.search.voyageLeg,
                        vesselName: this.search.vesselName,
                        vesselCode: this.search.vesselCode,
                        pageNum: this.popPageNum,
                        pageSize: this.popPageSize
                    },
                    headers: {
                        'Accept-language': localStorage.getItem("locale")
                    }
                }).then(response => {
                    this.responseCode = response.data.backMessage;
                    if (response.data.backCode === "200") {
                        this.popData = response.data.object.list;
                        this.popTotal = response.data.object.total;
                    } else {
                        this.showMessage(false, this.responseCode, "error");
                    }
                    this.isVVLSearchClick = false;
                }).catch(error => {
                    if (error.data) {
                        this.responseCode = error.data.backMessage;
                        this.showMessage(false, this.responseCode, "error");
                    } else {
                        this.showMessage(false, error, "error");
                    }
                    this.isVVLSearchClick = false;
                });
                //每次查询结束清空popVVLTableSelection
                this.popVVLTableSelection = [];
            },
            /**
             * 确认按钮点击事件
             */
            popConfirm() {//确认按钮点击,赋值选中记录的船名和航次到VVL查询输入框中
                if (this.popVVLTableSelection.length !== 0) {//获取弹框中最后选中的记录
                    this.popRowDblclick(this.popVVLTableSelection[0]);
                }
                this.$refs.popover.showPopper = false;
            },
            /**
             * 关闭按钮点击事件
             */
            closePopoverView() {//关闭按钮点击
                this.popData = [];
                this.popVVLTableSelection = [];
                this.$refs.popover.showPopper = false;
            },
            /**
             * 船名航次弹框数据分页条
             */
            popHandleDemand() {
                this.vvlSearch();
            },
            popHandleSizeChange(val) {
                this.popPageSize = val;
                this.popHandleDemand();
                this.$emit("backTop");
            },
            popHandleCurrentChange(val) {
                this.popPageNum = val;
                this.popHandleDemand();
                this.$emit("backTop");
            },
            /**
             * 船名航次表格行点击击事件
             */
            popRowClick(row) {
                this.popVVLTableSelection = [row];
            },
            /**
             * 船名航次表格行双击事件（某行被双击时,自动关闭弹框,获取该行船名航次数据,赋值订舱查询页船名航次输入框）
             */
            popRowDblclick(row) {
                this.search.vesselCode = row.vesselCode;
                this.search.voyageNo = row.voyageNo;
                this.search.voyageLeg = row.voyageLeg;
                this.$refs.popover.showPopper = false;
            },

            /************************************ 其他事件 *************************************/
            handleViewStyle(data){
                // 切换展示风格
                this.showViewFlag = data.value;
                // 将展示风格存到session中
                sessionStorage.setItem("VIEW_STYLE",this.showViewFlag);
            },
            updateInvoiceStatusOptions(val) {
                // 确认状态改变时自动清空开票状态
                this.search.invoiceStatus = "";
                if(val == null){
                    // 默认显示全部选项
                    this.invoiceStatusOptions = [
                        {codeValue: 1, displayValueCn: "未开票", displayValue: "UNINVOICED", disabled:false},
                        {codeValue: 2, displayValueCn: "部分开票", displayValue: "PARTIAL INVOICED", disabled:false},
                        {codeValue: 3, displayValueCn: "已开票", displayValue: "INVOICED", disabled:false},
                    ];
                } else if(val === 0 || val === 2){
                    // 查询未确认/取消确认对账单时，开票状态除未开票外全部选项禁用（此处的未开票代表商务对账单未结转到财务）
                    this.invoiceStatusOptions = [
                        {codeValue: 0, displayValueCn: "未开票", displayValue: "UNINVOICED", disabled:false},
                        {codeValue: 2, displayValueCn: "部分开票", displayValue: "PARTIAL INVOICED", disabled:true},
                        {codeValue: 3, displayValueCn: "已开票", displayValue: "INVOICED", disabled:true},
                    ];
                } else if(val === 1){
                    // 查询已确认对账单时，开票状态全部选项均可用
                    this.invoiceStatusOptions = [
                        {codeValue: 1, displayValueCn: "未开票", displayValue: "UNINVOICED", disabled:false},
                        {codeValue: 2, displayValueCn: "部分开票", displayValue: "PARTIAL INVOICED", disabled:false},
                        {codeValue: 3, displayValueCn: "已开票", displayValue: "INVOICED", disabled:false},
                    ];
                }
            },
            /**
             * 刷新表格记录选中状态，恢复未选中状态
             */
            refreshChecked(tableData){
                // 清空对账单表格数据多选列表
                this.tableBillReceivableDataChecked = [];
                if(tableData == null || tableData.length <= 0){
                    return [];
                }
                tableData.forEach((data)=>{
                    data.checked = false;
                    // 处理数字格式
                    data.amount = this.formatNumber(data.amount,2);
                });
                return tableData;
            },
            /**
             * 长文本获取缩略内容显示，鼠标悬停时弹出文字提示，显示全部内容
             */
            getSimplyContent(content) {
                if(content == null || content === "" || content.length <= 25){
                    return content;
                }
                // 超过25字符则省略显示
                return content.substring(0, 25) + "...";
            },
            /**
             * 数字格式转换公共方法
             */
            formatNumber(number, decimals) {
                if (number !== "") {
                    let formatNumber = "";
                    //去掉非法字符
                    number = (number + '').replace(/[^\d.]/g, '')
                    // 必须保证第一个为数字而不是. 输入第一位为.默认补充0
                        .replace(/^\./g, '0.')
                        // 保证只有出现一个.而没有多个.
                        .replace(/\.{2,}/g, '.')
                        // 保证.只出现一次，而不能出现两次以上
                        .replace('.', '$#$')
                        .replace(/\./g, '')
                        .replace('$#$', '.');
                    let strs = number.split('.');
                    if (strs.length === 1) {
                        formatNumber = strs[0];
                    } else if (strs.length > 1) {
                        strs[1] += "00";
                        if (strs[1].length > decimals) {
                            strs[1] = strs[1].substring(0, decimals);
                        }
                        formatNumber = strs.join('.');
                    }
                    return formatNumber;
                }
            },
            /**
             * 获取当前系统语言
             */
            getCurLanguage() {
                return localStorage.getItem('locale');
            },
            /**
             * 接口显示国际化（公共方法）
             */
            getDisplayValue(item){
                return localStorage.getItem('locale') == 'en'? item.displayValue : item.displayValueCn
            },
            /**
             * 获取确认状态显示值
             */
            getConfirmStatusDisplay(data){
                let value = {};
                this.confirmStatusOptions.forEach((option) => {
                    if (option.codeValue == data.confirmFlag) {
                        value = option;
                    }
                });

                if (value !== {}) {
                    return localStorage.getItem('locale') == 'en' ? value.displayValue : value.displayValueCn;
                } else {
                    return data.confirmFlag;
                }
            },
            /**
             * 获取开票状态显示值
             */
            getInvoiceStatusDisplay(data){
                let value = {};
                this.invoiceStatusOptions.forEach((option) => {
                    if (option.codeValue == data.invoiceFlag) {
                        value = option;
                    }
                });

                if (value !== {}) {
                    return localStorage.getItem('locale') == 'en' ? value.displayValue : value.displayValueCn;
                } else {
                    return data.invoiceFlag;
                }
            },

        },
        mounted() {
            // 页面渲染完成后初始化数据展示风格
            if(sessionStorage.getItem("VIEW_STYLE") != null){
                this.showViewFlag = sessionStorage.getItem("VIEW_STYLE");
            } else{
                this.showViewFlag = "card";//默认展示卡片视图
            }
        },
        created() {
            this.$parent.updateHeaderAside();
        },
        activated() {
            // //当对账单表格有数据时需自动查询最新数据
            // if (this.tableBillReceivableData.length > 0) {
            //     this.searchBtnClick();
            // }
        }
    };
</script>
<style rel="stylesheet/scss" lang="scss" scoped>
    @import "../../../assets/scss/base";
    @import "../../../assets/scss/public";

    /*列表展示*/
    .contentListCom{min-height: 264px;}
    .contentListCom .oneContent{width: 100%;margin-bottom: 10px;margin-top: 5px;}
    .contentListCom .top{height: 40px;border: 1px solid #E8E8E8;background: #E9E9E9;padding-left: 18px;line-height: 40px;}
    .contentListCom .center{min-height:85px ;padding: 15px 0 15px 17px;border: 1px solid #E8E8E8;background: #FFFFFF;border-top: none}
    .contentListCom .bottom{height: 40px;border: 1px solid #E8E8E8;background: #FFFFFF;border-top: none;line-height: 40px;}
    .contentListCom .listContentLong{width: 330px;overflow: hidden;white-space: nowrap;text-overflow: ellipsis;color: #606266;margin-top: 5px;}
    .contentListCom .listContentShort{width: 200px;overflow: hidden;white-space: nowrap;text-overflow: ellipsis;color: #606266;margin-top: 5px;}
    .contentListCom .listContent{width: 250px;overflow: hidden;white-space: nowrap;text-overflow: ellipsis;color: #606266;margin-top: 5px;}
    .contentListCom .listContent .thirdSpan{margin-left: 5px;display: inline-block}
    .contentListCom .center .listContent{font-size: 15px;height: 20px;line-height: 20px;}
    .contentListCom .center .listContent .secondSpan{color: #031B28;}
    .contentListCom .center .shortListContent{width: 200px}
    .contentListCom .center .longListContent{width: 300px}
    .contentListCom .listContent.rightMoney{text-align: right;margin-right: 5px}
    /*列表展示的单选和费用明细按钮*/
    .contentListCom .top{position: relative}
    .contentListCom .top .evaluateBtn{margin-left: 10px;border-radius: 4px}
    .contentListCom .top .feeDetail{position: absolute;right: 5px;top: 5px}
    .contentListCom .top .checkOne{margin-right: 5px;margin-top: 5px}
    /*列表展示图标位置*/
    .contentListCom .center{position: relative}
    .typeImg{ width: 160px;height: 125px;position: absolute;right: 10px;top: 6px;}
    .flexDiv{display: flex;flex-wrap: wrap;}
    /*列表展示协议价订单等内容展示*/
    .leftMessage .msg{line-height: 39px;margin-left: 10px;color: #606266;overflow: hidden;white-space: nowrap;text-overflow: ellipsis;}
    .xyj{width: 72px;color: #BC1920!important;}
    .auditMes{max-width: 95px;}
    .documentValid{margin-top: 5px;font-weight: bold}
    .documentValidLong{width: 280px;margin-top: 5px;font-weight: bold}
    .flexDiv .normalListButton{margin-right: 3px;}
    .flexDiv .normalListButton1{margin-right: 3px;margin-top: 2px}
    .flexDiv .normalListBlueButton{margin-right: 3px;background: $colorJ;color: $colorA;border: 1px solid #F6F6F6;}
    .flexDiv .normalListRedButton{margin-right: 3px;background: $colorC;color: $colorA;border: 1px solid #F6F6F6;}
    .hasBack{background-color: #567E8D;color: #fff}
    .hasBack:hover{background-color: #354953!important;color: #fff!important;}

    /*其他常用*/
    .visCom{visibility: hidden}
    .overflow{overflow: hidden}
    .l{float: left}
    .r{float: right}
    .flexDiv{display: flex;flex-wrap: wrap;}

    .jdt_nr {
        width: 50%;
        margin: 0 auto;
        z-index: 10001;
        top: 50%;
        margin-top: -31px;
        text-align: center;
        position: absolute;
        margin-left: 25%
    }

    .inputName {
        flex: 1;
        margin: 0 5px;
    }

    .topMargin {
        margin-top: 20px;
    }

    .searchBtn {
        display: flex;
        flex: 1;
        justify-content: flex-end;
        margin: 0 5px;
    }

    .voyageIcon {
        margin-left: 10px;
        margin-top: 5px;
        width: 30px;
        height: 30px;
        border: 1px solid #0091ff;
        border-radius: 4px;
    }

    .noData {
        height: 100%;
        margin: 15px 0;
        background-color: #ffffff;
    }

    .searchList {
        margin: 15px 0;
    }

    /deep/ .el-input-group__prepend {
        background-color: #d9e3f0;
    }

    .popoverView {
        padding: 5px;
        background-color: #ffffff;
    }

    .popoverInner {
        margin: 5px;
        margin-top: 0;
    }

    .flex1 {
        flex: 1;
    }

    .boatBox {
        position: relative;

        .boatBox-list-box {
            min-width: 280px;
            position: absolute;
            left: 51px;
            top: 30px;
            background: $colorA;
            padding: 5px 10px;
            z-index: 100;
            border: 1px solid $colorE;
            font-size: $fontC;
            font-weight: 600;

            .boatBox-top {
                width: 100%;
                height: 20px;
                line-height: 20px;
                background: $colorB;
            }

            .left {
                width: 30%;
                margin-right: 4%;
            }

            .right {
                width: 66%;
            }

            ul {
                padding: 0;
                margin: 0;

                li {
                    border-bottom: 1px solid #e7f0fc;
                    padding: 4px 2px;
                }

                li:last-of-type {
                    border: none;
                }

                li:hover {
                    background: rgb(224, 240, 245);
                }
            }
        }
    }

    .el-upload{
        .el-upload-dragger{
            width: 700px;
        }
    }

    .cardTitle {
        margin-bottom: 10px;

        span {
            font-size: $fontC;
            color: $colorF;
            letter-spacing: 0;
            font-weight: 600;
            margin-left: 6px;
        }
    }

    .my-upload-demo ::v-deep .el-upload {
        .el-upload-dragger {
            background-color: #fff;
            border: 1px dashed #d9d9d9;
            border-radius: 6px;
            box-sizing: border-box;
            width: 800px;
            height: 180px;
            text-align: center;
            cursor: pointer;
            position: relative;
            overflow: hidden;
        }
    }

    // 未确认图标
    .accountUnconfirmedImg {
        background-image: url(../../../assets/image/accountUnconfirmed.jpg) !important;
        background-repeat: no-repeat;
    }
    .accountUnconfirmedImgEn {
        background-image: url(../../../assets/image/accountUnconfirmedEn.jpg) !important;
        background-repeat: no-repeat;
    }


    // 已确认图标
    .accountConfirmedImg {
        background-image: url(../../../assets/image/accountConfirmed.png) !important;
        background-repeat: no-repeat;
    }
    .accountConfirmedImgEn {
        background-image: url(../../../assets/image/accountConfirmedEn.jpg) !important;
        background-repeat: no-repeat;
    }

    // 取消确认图标
    .cancelConfirmedImg {
        background-image: url(../../../assets/image/cancelConfirmed.jpg) !important;
        background-repeat: no-repeat;
    }
    .cancelConfirmedImgEn {
        background-image: url(../../../assets/image/cancelConfirmedEn.jpg) !important;
        background-repeat: no-repeat;
    }

    // 未开票图标
    .accountUnInvoicedImg {
        background-image: url(../../../assets/image/accountUnInvoiced.jpg) !important;
        background-repeat: no-repeat;
    }
    .accountUnInvoicedImgEn {
        background-image: url(../../../assets/image/accountUnInvoicedEn.jpg) !important;
        background-repeat: no-repeat;
    }

    // 部分开票图标
    .accountPartInvoicedImg {
        background-image: url(../../../assets/image/accountPartInvoiced.jpg) !important;
        background-repeat: no-repeat;
    }
    .accountPartInvoicedImgEn {
        background-image: url(../../../assets/image/accountPartInvoicedEn.jpg) !important;
        background-repeat: no-repeat;
    }

    // 已开票图标
    .accountInvoicedImg {
        background-image: url(../../../assets/image/accountInvoiced.jpg) !important;
        background-repeat: no-repeat;
    }
    .accountInvoicedImgEn {
        background-image: url(../../../assets/image/accountInvoicedEn.jpg) !important;
        background-repeat: no-repeat;
    }

    //重写el-textarea样式，更改默认高度
    .inputName{
        /deep/.el-textarea__inner{
            line-height: 1;
            display: block;
            resize: vertical;
            padding: 5px 15px;
            box-sizing: border-box;
            width: 100%;
            font-size: inherit;
            color: #606266;
            background-color: #FFFFFF;
            background-image: none;
            border: 1px solid #DCDFE6;
            border-radius: 4px;
            transition: border-color 0.2s cubic-bezier(0.645, 0.045, 0.355, 1);
        }
    }

</style>
<style lang="scss">
    .el-tabs__content {
        background: #fff;
    }

    //全选icon
    .el-icon-my-selectAll {
        background: url('../../../assets/image/icon/selectAll.png') center center no-repeat;
        font-size: 16px;
        background-size: cover;
    }

    .el-icon-my-selectAll:before {
        content: "替";
        font-size: 16px;
        visibility: hidden;
    }

    //反选icon
    .el-icon-my-selectInverse {
        background: url('../../../assets/image/icon/selectInverse.png') center center no-repeat;
        font-size: 16px;
        background-size: cover;
    }

    .el-icon-my-selectInverse:before {
        content: "替";
        font-size: 16px;
        visibility: hidden;
    }

</style>